<template>
  <svg width="50" height="8" viewBox="0 0 50 8" fill="inherit" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 3.84615C50 5.97356 48.2812 7.69231 46.1538 7.69231H3.84615C1.71875 7.69231 0 5.97356 0 3.84615C0 1.71875 1.71875 0 3.84615 0H46.1538C48.2812 0 50 1.71875 50 3.84615Z" fill="inherit"/>
  </svg>
</template>